class RequestError {
    status: number;
    message: string;
    constructor(status: number, message: string) {
        this.status = status;
        this.message = message;
    }

    toString() {
        return `${this.status}: ${this.message}`;
    }
}

const PG_ERROR_PREFIX = 'error: ';

export function post(url: string, data = {}): Promise<{data: any}> {
    return new Promise(function(resolve, reject) {
        const request = new XMLHttpRequest();
        request.onreadystatechange = function() {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve({status: this.status, data: JSON.parse(this.response)});
                } else {
                    reject(new RequestError(this.status, this.response || this.statusText));
                }
            }
        };
        request.onerror = function() {
            reject(new Error('XMLHttpRequest Error: ' + this.statusText));
        };
        request.open('POST', url);
        request.setRequestHeader('content-type', 'application/json');
        request.send(JSON.stringify(data));
    }).catch((result) => {
        if (result.status === 401) {
            const current_location = window.location.href;
            window.location.href = '/login?redirect=' + encodeURIComponent(current_location);
        }
        if (result.status === 422) { // error code that represents intentional error thrown by db for bad data
            try {
                const parsedError = JSON.parse(result.message);
                if (parsedError.message && parsedError.message.indexOf(PG_ERROR_PREFIX) === 0) {
                    result = JSON.parse(parsedError.message.substring(PG_ERROR_PREFIX.length));
                }
                throw result;
            }
            catch (e) {
                throw result;
            }
        }
        throw result;
    });
}

function serialize(obj: {[key: string]: string}) {
    const str: Array<string> = [];
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    }
    return str.join("&");
}

export function get(url: string, data = {}): Promise<{data: any}> {
    const qs = serialize(data);
    url += !qs.length ? '' : ('?' + qs);
    return new Promise(function(resolve, reject) {
        const request = new XMLHttpRequest();
        request.onreadystatechange = function() {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve({status: this.status, data: JSON.parse(this.response)});
                } else {
                    reject(new RequestError(this.status, this.response || this.statusText));
                }
            }
        };
        request.onerror = function() {
            reject(new Error('XMLHttpRequest Error: ' + this.statusText));
        };
        request.open('GET', url);
        request.send();
    });
}



// WEBPACK FOOTER //
// ./_src/services/ferry/xmlHttpWrapper.ts